import { Button, Input } from "@medbillai/ui";

/** A detail we already have, shown as a disabled field with an Edit action. */
export function ConfirmedField({
  label,
  value,
  editLabel,
  onEdit
}: {
  label: string;
  value: string;
  editLabel: string;
  onEdit: () => void;
}) {
  return <Input disabled label={label} value={value} rightElement={<Button variant="tertiary" size="small" fillWidth={false} aria-label={editLabel} onPress={onEdit}>
          Edit
        </Button>} data-sentry-element="Input" data-sentry-component="ConfirmedField" data-sentry-source-file="ConfirmedField.tsx" />;
}